<template>
  <hr class="divider" :class="{ 'divider--flush-bottom-tablet': flushBottomOnTablet }" />
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    /** На планшете и мобильном убирает нижний отступ (разделитель перед блоком с картой). */
    flushBottomOnTablet?: boolean;
  }>(),
  {
    flushBottomOnTablet: false,
  },
);
</script>

<style scoped lang="scss">
.divider {
  margin: 24px 0;
  border: none;
  border-top: 1px solid var(--alias-color-border-default, rgb(0 0 0 / 10%));

  &--flush-bottom-tablet {
    @include tablet {
      margin: 24px 0 0;
    }
  }
}
</style>
